export default "__VITE_ASSET__ghwYQthv__"